/**
 * User Microservice
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type UserRoles = 'User' | 'HelpDeskUser' | 'AdminUser' | 'MspAdmin' | 'SuperAdmin';

export const UserRoles = {
    User: 'User' as UserRoles,
    HelpDeskUser: 'HelpDeskUser' as UserRoles,
    AdminUser: 'AdminUser' as UserRoles,
    MspAdmin: 'MspAdmin' as UserRoles,
    SuperAdmin: 'SuperAdmin' as UserRoles
};

